/**
 * ClawInstall FAQ (`/faq`) — eager half of the route. Registers the file
 * route with its SSR head only; the page component, the FAQ JSON-LD builder,
 * and every design / seam / atom import live in `faq.lazy.tsx` so they load
 * with this route and never land in the always-loaded `main` chunk (the
 * `entryChunkGzipKb` budget, CLA-645). Mounted outside the `/clawinstall`
 * layout (trailing-underscore escape) so the frame's `<main>` is the only main
 * landmark.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { identityFromHeadCtx, publicPageHead } from "~/lib/clawinstall-marketing-head.ts";

/** SSR head for `/faq`: identity-scoped title/canonical, host-agnostic answers description. @since 1.0.0 */
export const faqHead = (ctx?: Parameters<typeof identityFromHeadCtx>[0]) => {
  const identity = identityFromHeadCtx(ctx);
  return publicPageHead({
    path: "/faq",
    title: `FAQ — ${identity.displayName}`,
    description:
      `Straight answers about what ${identity.displayName} is, where your data goes, and what happens when things break.`,
    identity,
  });
};

export const Route = createFileRoute("/clawinstall_/faq")({
  head: faqHead,
});
